import vuex from 'vuex';

const bannerManage = {
    state: {
        bannerDetailData: {}
    },
    mutations: {
        SET_BANNER_DETAIL_DATA (state,data) {
            state.bannerDetailData = data
        }
    },
    actions: {
        
    }
}

export default bannerManage


// WEBPACK FOOTER //
// ./src/store/modules/bannerManage.js